import { useEffect } from 'react'

import { PasswordResetPanel } from '../../components/panels'

/**
 * 
 * Renders the PasswordResetPanel component and sets the document title to 'Redefinir Senha | LCD' using the useEffect hook.
 * 
 * @author Maria Eduarda Franke
 * @returns {JSX.Element}  The PasswordResetPanel component.
 */
const PasswordResetPage = () => {

    useEffect(() => {
        document.title = 'Redefinir Senha | LCD'
    }, [])

    return (
        <PasswordResetPanel />
    )
}

export default PasswordResetPage